import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Jobs from "./pages/Jobs";
import Apply from "./pages/Apply";
import ApplyState from "./pages/ApplyState";
import ForEmployers from "./pages/ForEmployers";
import ForCandidates from "./pages/ForCandidates";
import Contact from "./pages/Contact";
import CareerPathway from "./pages/CareerPathway";
import Enroll from "./pages/Enroll";
import EnrollLogin from "./pages/EnrollLogin";
import EnrollForgotPassword from "./pages/EnrollForgotPassword";
import EnrollResetPassword from "./pages/EnrollResetPassword";
import EnrollPortal from "./pages/EnrollPortal";
import EnrollPortalLegacy from "./pages/EnrollPortalLegacy";
import VerifyId from "./pages/VerifyId";
import VerifyCertificate from "./pages/VerifyCertificate";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ThankYou from "./pages/ThankYou";
import StickyApplyBar from "./components/StickyApplyBar";
import { trackPageView, captureAttribution } from "./lib/analytics";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function RouteTracker() {
  const { pathname, search } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    captureAttribution();
    if (first.current) { first.current = false; return; }
    trackPageView(pathname + search);
  }, [pathname, search]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main className="pt-0">{children}</main>
      <div className="h-20 md:hidden" aria-hidden />
      <Footer />
      <StickyApplyBar />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <ScrollToTop />
        <RouteTracker />
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            style: { fontFamily: "Outfit, sans-serif" },
          }}
        />
        <Routes>
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/jobs" element={<PublicLayout><Jobs /></PublicLayout>} />
          <Route path="/apply/:jobId" element={<PublicLayout><Apply /></PublicLayout>} />
          <Route path="/thank-you" element={<PublicLayout><ThankYou /></PublicLayout>} />
          <Route path="/state/:code" element={<PublicLayout><ApplyState /></PublicLayout>} />
          <Route path="/for-employers" element={<PublicLayout><ForEmployers /></PublicLayout>} />
          <Route path="/for-candidates" element={<PublicLayout><ForCandidates /></PublicLayout>} />
          <Route path="/career-pathway" element={<PublicLayout><CareerPathway /></PublicLayout>} />
          <Route path="/enroll" element={<Enroll />} />
          <Route path="/enroll/login" element={<EnrollLogin />} />
          <Route path="/enroll/forgot-password" element={<EnrollForgotPassword />} />
          <Route path="/enroll/reset-password" element={<EnrollResetPassword />} />
          <Route path="/enroll/portal" element={<EnrollPortal />} />
          <Route path="/enroll/portal/:token" element={<EnrollPortalLegacy />} />
          <Route path="/verify-id" element={<VerifyId />} />
          <Route path="/verify/:prcId" element={<VerifyCertificate />} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
